import { Component,ViewChild } from '@angular/core';
import { NavController,ViewController,NavParams,Platform,ToastController,AlertController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { provider } from '../../../providers/provider';
import { Slides } from 'ionic-angular';
import { CartPage } from '../../cart/cart';
import { CustomizerProvider } from '../../../providers/customizer/customizer';

@Component({
  selector: 'page-slotslist',
  templateUrl: 'slotsList.html'
})
export class SlotsListPage {
  @ViewChild(Slides) slides: Slides;
  url: any;
  groupId = '';
  groupContentId = '';
  viewType = 'no-list-image';
  groupContent: any;
  data: any;
  tot = 0;
  width: any;
  height: any;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translateService: TranslateService,
              public storage: Storage,
              public viewCtrl: ViewController,
              public toastCtrl: ToastController,
              public alertCtrl: AlertController,
              public provider: provider,
              public customizer: CustomizerProvider,
              public platform: Platform) {
    this.url = provider.getUrl();
    this.data = provider.getMenu();
    let group = navParams.get('group');
    this.groupId = group._id;
    this.groupContentId = group.content._id;
    this.groupContent = group.content;

    platform.ready().then((readySource) => {
      this.width = platform.width();
      this.height = platform.height();
    });
  }

  getUrlImage(img) {
    if (this.viewType == 'horizontal') {
      let imageType = this.data.settings.imageType

      if(img.extraProps.imageType !== undefined) 
        imageType = img.extraProps.imageType;

      switch(imageType) {
        case 'S':
          return this.url + img.img + '?h=' + (this.height/4);
        case 'M':
          return this.url + img.img + '?h=' + (this.height/3);
        case 'L':
          return this.url + img.img + '?h=' + (this.height/2);
      }
    }
    else
      return this.url + img.img + '?h=56&w=56'; //&crop
  }

  addSlot(product) {
    let cart = this.provider.getCart();
    var item = {
      "quantita": 1,
      "varIngr": [],
      "prodotto": product,
      "max": 1,
      "cont": 0,
      "disponibilita": 1,
      "id": 'slot'
    }

    let toast = this.toastCtrl.create({
      message: "L'orario di prenotazione è stato inserito!",
      duration: 3000,
      position: 'middle'
    });

    let toast1 = this.toastCtrl.create({
      message: "L'orario di prenotazione è stato cambiato!",
      duration: 3000,
      position: 'middle'
    });

    let controlloSlot = true;
    for(let i=0; i<cart.length; i++) {
      if(cart[i].id == 'slot') {
        controlloSlot = false;
        cart[i].prodotto = product;
      } 
    }

    if(controlloSlot) {
      this.provider.addToCart(item);
      toast.present();
      this.navCtrl.pop();
    } else {
      toast1.present();
      this.navCtrl.pop();
    }

  }

  cart() {
    this.navCtrl.push(CartPage);
  }

  ionViewDidEnter() {
    this.tot = this.provider.showTotal();
  }

  ionViewDidLoad() {
    this.data.menu.righe.sort(function(a, b){
      return a.ordering-b.ordering
    });
  }

  hasExtendedDescription(group) : Boolean {
    return (group.descrizioneEstesa != undefined && group.descrizioneEstesa[0] != undefined && group.descrizioneEstesa[0].contenuto != '');
  }

}




// WEBPACK FOOTER //
// ./src/pages/products/slotsList/slotsList.ts